import request from '@/utils/request'

export const getProviders = (params: any) =>
  request({
    url: '/users',
    method: 'get',
    params: {
      role: 'ServiceProvider',
      perPage: params.perPage ?? 10,
      page: params.page ?? 1,
      'filters[query]': params.query ?? ''
    }
  })
